import { GarageIcon, ArrowsMinimizeIcon, WheelchairIcon, ElectricVehicleIcon, PadlockBigClosedIcon, ForbiddenIcon, GasPumpIcon, ArrowRotate24Icon, SunCloudIcon, MaximizeIcon, ElectricVehicleCharge100Icon, ElectricVehicleCharge200Icon, ElectricVehicleCharge300Icon, ElectricVehicleCharge400Icon, ElectricVehicleChargeOver400Icon, TruckUnder7tIcon, TruckUnder12tIcon, TruckNoLimitsIcon, SemiTruckIcon, } from '@repo/icons';
export const parkingPropertiesDictionary = {
    disabled: {
        icon: WheelchairIcon,
    },
    open24h: {
        icon: ArrowRotate24Icon,
    },
    indoor: {
        icon: GarageIcon,
    },
    outdoor: {
        icon: SunCloudIcon,
    },
    carport: {
        icon: GarageIcon,
    },
    guarded: {
        icon: PadlockBigClosedIcon,
    },
    lockable: {
        icon: PadlockBigClosedIcon,
    },
    lpgForbidden: {
        icon: ForbiddenIcon,
    },
    lpgFriendly: {
        icon: GasPumpIcon,
    },
    /* EV Charging */
    evChargingAc: {
        icon: ElectricVehicleIcon,
    },
    evChargingDcUnder100kW: {
        icon: ElectricVehicleCharge100Icon,
    },
    evChargingDc100To200kW: {
        icon: ElectricVehicleCharge200Icon,
    },
    evChargingDc200To300kW: {
        icon: ElectricVehicleCharge300Icon,
    },
    evChargingDc300To400kW: {
        icon: ElectricVehicleCharge400Icon,
    },
    evChargingDcOver400kW: {
        icon: ElectricVehicleChargeOver400Icon,
    },
    /* Size */
    compact: {
        icon: ArrowsMinimizeIcon,
    },
    xxl: {
        icon: MaximizeIcon,
    },
    truckUnder7t: {
        icon: TruckUnder7tIcon,
    },
    truck7To12t: {
        icon: TruckUnder12tIcon,
    },
    truckOver12t: {
        icon: TruckNoLimitsIcon,
    },
    truckSemi: {
        icon: SemiTruckIcon,
    },
};
